module.exports = __webpack_public_path__ + "fonts/LiberationSans-Italic.7f7e05e2.ttf";